export default "__VITE_ASSET__BVlh1lDu__"